// @ts-nocheck
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/DisplayOrder";

// Some condition is causing the cart to not load properly for the summary so we're going to force it to load
replaceInChain(chain, PopulateApiParameter, props => {
    props.apiParameter = {
        cartId: props.parameter.cartId,
        forceRecalculation: true,
        expand: ["cartLines", "hiddenproducts", "restrictions"],
    } as GetCartApiParameter;
});
